/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class FAQBlock extends React.Component {
    // The most billing annually saves on a plan the pricing table offers, rounded down so the FAQ
    // never promises more than checkout gives. 0 while there's no catalogue to work it out from.
    annualSaving() {
        let constants = this.props.app.config.constants,
            plans = this.props.plans || {},
            best = 0;

        [constants.PUB_LEVEL_6, constants.PUB_LEVEL_9, constants.PUB_LEVEL_8].forEach((level) => {
            let price = plans[level] ? plans[level].price : null;

            if (price && price[constants.SUBSCRIPTION_TERM_MONTHLY] > 0) {
                best = Math.max(best, 1 - price[constants.SUBSCRIPTION_TERM_ANNUAL] / (12 * price[constants.SUBSCRIPTION_TERM_MONTHLY]));
            }
        });

        // the epsilon keeps a saving of exactly 40% from flooring to 39 on float error
        return Math.floor(best * 100 + 1e-9);
    }

    render() {
        let planQ = null,
            constants = this.props.app.config.constants,
            saving = this.annualSaving(),
            level = (this.props.user !== undefined) ? parseInt(this.props.user.plan.planLevel, 10) : 1;

        if (this.props.newSubscription !== undefined) {
            level = this.props.newSubscription.level;
        }

        return (
            <div className="faq-block clearfix">
                <h3>{"Still have questions? We've got answers."}</h3>
                <ul className="faq-list">
                    <li>
                        <div className="faq-q">
                            {"Not 100% satisfied? Get your money back."}
                        </div>
                        <div className="faq-a">
                            New to dlvr.it? Try us risk free. If you're not satisfied let us know within 14 days of your first payment and get a full refund. <a href="https://support.dlvrit.com/hc/en-us/articles/40898354355739-14-day-money-back-guarantee" target="_blank">View details</a>.
                        </div>
                    </li>
                    <li>
                        <div className="faq-q">
                            Can I cancel at any time?
                        </div>
                        <div className="faq-a">
                            While we hate to see our friends leave, we make it easy to change or cancel your plan at anytime from the Account Settings page.
                        </div>
                    </li>
                    <li>
                        <div className="faq-q">
                            Do you offer any discounts?
                        </div>
                        <div className="faq-a">
                            {saving > 0
                                ? `Yes, we do! Save up to ${saving}% when you sign up for an annual plan.`
                                : 'Yes, we do! Save when you sign up for an annual plan.'}
                        </div>
                    </li>
                    <li>
                        <div className="faq-q">
                            What forms of payment do you accept?
                        </div>
                        <div className="faq-a">
                            We accept Visa, MasterCard, American Express, and Paypal.
                        </div>
                    </li>
                    <li>
                        <div className="faq-q">
                            Do you offer any discounts for non-profits?
                        </div>
                        <div className="faq-a">
                            We offer a 50% discount to non-profit organizations. To receive a nonprofit discount, please send over your 501c3 or the country equivalent to support your nonprofit status. Once we've confirmed your status, we'll apply the 50% discount to all future payments. If you've already made the upgrade, we'll refund 50% of your most recent payment.
                        </div>
                    </li>
                    <li>
                        <div className="faq-q">
                            Who else uses dlvr.it?
                        </div>
                        <div className="faq-a">
                            Over 1,000,000 individuals, businesses, and brands trust dlvr.it to post more than 5M items daily to over a billion friends, fans and followers. We put smart social media automation to work for discerning curators around the globe.
                        </div>
                    </li>
                </ul>
            </div>
        );
    }

};

export default FAQBlock;
